import styles from "./styles.module.scss"
import modalStyles from "../../modals.module.scss"
import commonOnboardingStyles from "../common.module.scss"
import { TypographyH2, TypographyP } from "@/components/ui/typography"
import { type GetMyOptionsDtoResVoiceLang } from "@/shared/api/generated"
import { useState } from "react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import {
  getDefaultLanguage,
  OnboardingStep,
  useOnboardingStore,
} from "../model"
import {
  DISCOVERED_TRANSLATION_KEYS,
  LANG_KEYS,
  LANGUAGE_VOICES,
} from "@/shared/constants"
import { useAutoTranslation } from "@/entities"

export const OnboardingModalSelectLanguage = () => {
  const { t } = useAutoTranslation()
  const [selectedLanguage, setSelectedLanguage] =
    useState<GetMyOptionsDtoResVoiceLang>(getDefaultLanguage())

  const handleConfirm = () => {
    const store = useOnboardingStore.getState()
    store.setSelectedLanguage(selectedLanguage)
    store.setStep(OnboardingStep.SELECT_VOICE)
  }

  return (
    <div className={modalStyles.backdrop}>
      <div className={commonOnboardingStyles.wrapper}>
        <div className={cn(commonOnboardingStyles.card, "h-auto!")}>
          <div className={commonOnboardingStyles.card__header}>
            <TypographyH2>
              {t(
                DISCOVERED_TRANSLATION_KEYS.PICK_ALANGUAGE_FOR_YOUR_AUDIO_SVOICE
              )}
            </TypographyH2>
            <TypographyP className="mt-0">
              {t(
                LANG_KEYS.DON_T_WORRY_YOU_CAN_SWITCH_IT_ANYTIME_LATER_IN_SETTINGS
              )}
            </TypographyP>
          </div>

          <div
            className={cn(commonOnboardingStyles.card__content, "max-h-unset")}
          >
            {LANGUAGE_VOICES.map(language => (
              <div
                key={`SELECT_LANGUAGE_${language.id}`}
                onClick={() => setSelectedLanguage(language.id)}
                className={cn(styles.item, {
                  [styles.item_active]: selectedLanguage === language.id,
                })}
              >
                <div className={styles.item__flag}>{language.flag({})}</div>
                <div className={styles.item__label}>{language.label}</div>
              </div>
            ))}
          </div>

          <div className={commonOnboardingStyles.card__footer}>
            <Button className="w-full" onClick={handleConfirm}>
              {t(LANG_KEYS.CONTINUE)}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
